// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3L1pe","row":"ProcedureTreatmentSummary_row__2q9kc"};